import { render, staticRenderFns } from "./bread.vue?vue&type=template&id=755f116a&scoped=true&"
import script from "./bread.vue?vue&type=script&lang=js&"
export * from "./bread.vue?vue&type=script&lang=js&"
import style0 from "./bread.vue?vue&type=style&index=0&id=755f116a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755f116a",
  null
  
)

export default component.exports